import ReactController from '~/controllers/react_controller'
import AWSEBSDashboardCharts from '~/dashboard/aws_ebs_dashboard_charts'

export default class AWSEBSDashboardChartsController extends ReactController {
  static values = {
    organizationId: String,
  }

  createComponent() {
    return <AWSEBSDashboardCharts organizationId={this.organizationIdValue} />
  }
}
